export const formatCurrency = (value?: number | null, currency?: string) => {
  const amount = value ?? 0
  const isNegative = amount < 0
  const [intPart, decPart] = Math.abs(amount).toFixed(2).split('.')
  const groupedIntPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  const formatted = `${isNegative ? '-' : ''}${groupedIntPart},${decPart}`
  return currency ? `${formatted} ${currency}` : formatted
}
